import React, { useState, useEffect, useRef, useContext, useLayoutEffect  } from 'react';
import { useLocalStorage } from '_context/commonHooks';
import { MapContext } from '_context/MapContext';
import {useToggle} from '_context/commonHooks';
import { PlaceList, AddrResult, AddrList } from 'component/PlaceList';
import { LayoutContext } from '_context/LayoutContext';

import btn_google from 'resources/imgs/btn_google_gray.png';
import btn_appstore from 'resources/imgs/btn_appstore_gray.png';
import util from 'common/util'

const addComma = (val) => {
	return (val===undefined)?0:val.toLocaleString();
}

const convertSecond = (sec) => {
	var hrs = Math.floor(sec / 3600);
	var min = Math.floor((sec - (hrs * 3600)) / 60);

	var result = (hrs)?hrs+"시간":"";
	result += (min)?min+"분":"";
	return result;
}

const convertKm = (val) => {
	if(val<=0){return "";}
	if(val<1000){ return val+"m";}
	var km = val/1000;
	return km.toFixed(1)+"km";
}

const RPSummary = ({data}) => {
	const [isPOP, setIsPOP] = useToggle(false);
	const { chgStatus } = useContext(LayoutContext);
	let loadcnt = 0;
	let mid = 0
	if(data.roadSummary){
		loadcnt = data.roadSummary.roadInfos.length;
		mid = Math.floor(loadcnt / 2);
	}

	if(loadcnt===0){return null;}

	const roadSummary = (val,i) => {
		if(!data.roadSummary){
			return ''
		}
		return (
			<li>
				<span className={"state co"+i}>원활</span>
				<span className="name">{data.roadSummary.roadInfos[val].roadName}</span>
				<span className="range">{convertKm(data.roadSummary.roadInfos[val].roadLength)}</span>
			</li>
		)
	}

	return (
		<div className="innerTop">
		<div className="dv1">
			<span className="time">{convertSecond(data.time)}</span>{' '}
			<span className="range">{convertKm(data.distance)}</span>
		</div>
		<div className="dv2">
			<span>주유비 {addComma(data.energy_prices)}원 </span>
			<span>통행료 {addComma(data.totalToll)}원</span>
		</div>
		<div className="dv3">
			<ul>
				{roadSummary(0,1)}
				{roadSummary(mid,2)}
				{roadSummary(loadcnt-1,3)}
			</ul>
		</div>
		<div className="btnsWrap">
			{/* <button className="btnsNavi btnBookmark"  title="즐겨찾기">즐겨찾기</button> */}
			<button className="btnsNavi btnDrive" title="드라이브" onClick={() => chgStatus('simul')}>드라이브</button>
			<button className="btnsNavi btnSearch"  title="검색" onClick={() => chgStatus('routeNear')}>검색</button>
			{/* <button className="btnsNavi btnOnenavi" title="원네비">원네비</button> */}
		</div>
		{
			isPOP && 
			<div className="lyBox" id="lypopOneNavi">
			<div className="inner wrapOneNavi">
				<div className="txt1">
					지금 원내비 앱에 <span>적극추천경로</span>를<br/>전송하시겠습니까?
				</div>
				<div className="txt2">
					<a href="#">원내비 실행하기</a>
				</div>
				<div className="btnWrap">
					<a href="#"><img src={btn_google} alt="google play"/></a>
					<a href="#"><img src={btn_appstore} alt="apple appstore"/></a>
				</div>
			</div>
			<button className="btnsSch btnClose" onClick={() => setIsPOP()}>닫기</button>
		</div>
		}
		

	</div>
	)
}

const RPList = ({item,idx,isActive}) => {
	const { rpOpts, setRPOpts, } = useContext(MapContext);

	const setTbtIdx=(idx)=>{
		setRPOpts("selectedTbt",idx+1)
	}

	return (
		<li  id={"tbtlist-"+(idx+1)} onClick={()=>setTbtIdx(idx)} style={{cursor:'pointer'}} className={isActive ? "current":""}>
			{/* <img src="" alt=""/> */}
			<span className="num">{idx+1}</span>
			{item.displayName}{' '}{item.tbtInfoName} {' '}<font className="tbtDistance">{convertKm(item.nextDistance)}</font>
		</li>
	)
}

const RPTabIn = ({data,start,end}) => {
	const { rpOpts, setRPOpts,selectedTbt } = useContext(MapContext);

	const setRouteAll=()=>{
		let guid = util.guid();
		setRPOpts("routeViewAll",guid)
	}

	return(
<div id="tabRoute-1" className="tabCont" style={{display:'block'}}>
					<RPSummary data={data} />
					<div className="innerCont">
						<ul>
							<li>
								<span className="spoint crStart">출발</span>
								{data.tbts&&data.tbts.length>0?data.tbts[0]['tbtInfoName']:''}
								<a className="view" onClick={setRouteAll} style={{cursor:'pointer'}}>전체경로보기 <span className="iconsArrow"></span></a>
							</li>
							<ol className="detail">
							{
								(data.tbts).slice(1,-1).map((item,i)=>{
									return <RPList item={item} idx={i} key={i} isActive={selectedTbt===(i+1)?true:false}/>
								})
							}
							</ol>
							<li>
								<span className="spoint crDest">도착</span>
								{data.tbts&&data.tbts.length>0?data.tbts[data.tbts.length-1]['tbtInfoName']:''}
							</li>
						</ul>
					</div>
				</div>
	)
}

export const RPResult = ({data,start,end}) => {

const { rpOpts, setRPOpts } = useContext(MapContext);
const [ rpIndex, setRpIndex ] = useState(0);
const arrTab=[{rpType:0,title:"적극추천"},{rpType:7,title:"가장빠름"},{rpType:3,title:"가장짧음"},{rpType:2,title:"통행료무료"}];

const onChangeRoute = (rpType) => {
	setRPOpts("rpType",rpType);
}

useEffect(() => {
	var idx = arrTab.findIndex(item => item.rpType === rpOpts.rpType);
	setRpIndex(idx);
  }, [rpOpts.rpType]);



  if(data.length<1){  return null}

    return (
        <React.Fragment>
        	<div className="tabMenu">
					<ul>
						{
							arrTab.map((item,i)=>{
								return <li key={i} className={rpOpts.rpType===item.rpType?"current":""} onClick={()=>onChangeRoute(item.rpType)} ><a>{item.title}</a></li>
							})
						}
					</ul>        
			</div>
            <RPTabIn data={data[rpIndex]} start={start} end={end} />
        </React.Fragment>
       
    );
  };
  
  export const WayPointSelect = ({data}) => {

	const { rpOpts,setRPOpts } = useContext(MapContext);

	if(data.length<1){  return null}

	const chgSelTitle=(idx)=>{
		let str="";
		if(idx===0){ str="적극 추천해요"}
		else if(idx===1){ str="가장 빨라요"}
		else if(idx===2){ str="가장 짧아요"}
		else if(idx===3){ str="통행료 무료에요"}
		return str;
	}

	const onChangeRoute = (idx) => {
		setRPOpts("rpType",idx);
	}

	return (
	<div className="wayPointSelect">
	{
		data.map((item,i)=>{
			return (
				<button className={
					"type" + (i+1)+
					(rpOpts.rpType===item.rpType ? " current" : "")
				  } onClick={()=>onChangeRoute(item.rpType)} key={i}>
				<span className="txt1">{chgSelTitle(i)}</span>
				<span className="txt2">{convertSecond(item.time)}</span>
				<span className="txt3">통행료 {addComma(item.totalToll)}원</span>
				<span className="txt4">{convertKm(item.distance)}</span>
				</button>
			)
		})
	}
	</div>
)
}